<!--
 * @Author: zxf
 * @Date: 2022-07-26 22:24:00
 * @LastEditors: zry
 * @LastEditTime: 2024-10-25 15:27:47
 * @Description: 维保计划新增/修改
-->
<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm-80 o-dialog--md-90 o-dialog--lg-75 o-dialog--xl-50"
    :title="dlTitle"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <div
      class="o-tips u-mg-b-10"
      style="margin-top: -10px;"
    >
      <div class="o-tips__title">
        {{ dlParams.id ? '说明：' : '说明：维保合同有效期内才可添加计划' }}
      </div>
      <ul
        v-if="dlParams.id"
        class="o-tips__body"
      >
        <li class="o-tips__item">
          1、计划维保内容如需更改请在维保项目管理更改客户的维保内容；
        </li>
        <li class="o-tips__item">
          2、生成报告后如需修改请用主账号开启重新修改功能。
        </li>
      </ul>
    </div>
    <el-form
      ref="fd"
      class="c-form"
      :model="fd"
      :rules="fdRules"
      :inline="true"
      label-position="right"
      label-width="110px"
      label-suffix="："
    >
      <el-row class="c-form__row">
        <el-col
          v-if="editShow"
          class="c-form__col c-form__part-title"
          :span="24"
        >
          维保计划
        </el-col>
        <el-col
          v-if="dlParams.id === undefined && $route.params.xmId === undefined"
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="项目名称"
            prop="xmId"
          >
            <el-select
              v-model="fd.xmId"
              class="c-form__select"
              placeholder="请选择"
              clearable
              @change="handleXmChange"
            >
              <el-option
                v-for="(item,index) in xmList"
                :key="index"
                :label="item.xmmc"
                :value="item.xmId"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col
          v-else
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="项目名称"
            prop="xmId"
          >
            <span>
              {{ fd.xmmc }}
            </span>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="合同有效期"
            prop="htyxq"
          >
            <span
              v-show="!fd.xmId"
              class="u-text-danger"
            >请选择项目</span>
            <span
              v-show="fd.xmId"
            >
              {{ htyxqQ | date('yyyy-MM-dd') }}
              至
              {{ htyxqZ | date('yyyy-MM-dd') }}
            </span>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="计划年份"
            prop="jhnf"
          >
            <span
              v-show="!fd.xmId"
              class="u-text-danger"
            >请选择项目</span>
            <el-select
              v-show="fd.xmId"
              v-model="fd.jhnf"
              class="c-form__select"
              placeholder="请选择"
              clearable
              @change="handleJhmc()"
            >
              <el-option
                v-for="(item,index) in jhnfList"
                :key="index"
                :label="item.text"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="维保周期"
            prop="jhlxDm"
          >
            <el-radio-group
              v-model="fd.jhlxDm"
              class="c-form__radio-group"
            >
              <el-radio
                v-for="item in jhlxList"
                :key="item.id"
                :label="item.id"
                @click.native="handleJhlxChange(item)"
              >
                {{ item.text }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>

        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            v-if="!editShow"
            class="c-form__item"
            label="计划名称"
            prop="jhmc"
          >
            <span
              v-show="!fd.jhnf || !fd.jhlxDm"
              class="u-text-danger"
            >请选择计划年份、维保周期</span>
            <el-select
              v-show="fd.jhnf && fd.jhlxDm"
              v-model="fd.jhmc"
              class="c-form__select"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="(item,index) in jhmcList"
                :key="index"
                :label="item.text"
                :value="item.id"
                @click.native="handleJhmcChange(item)"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            v-else
            class="c-form__item"
            label="计划名称"
            prop="jhmc"
          >
            <el-input
              v-model="fd.jhmc"
              class="c-form__input"
              placeholder="请输入计划名称"
              clearable
              maxlength="100"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="起止日期"
            prop="qzrq"
          >
            <span
              v-show="!fd.jhnf || !fd.jhlxDm"
              class="u-text-danger"
            >请选择计划年份、维保周期</span>
            <span
              v-show="fd.jhnf && fd.jhlxDm"
              class="c-form__read"
            >{{ fd.jhsjQ || '-' | date('yyyy-MM-dd') }} 至 {{ fd.jhsjZ || '-' | date('yyyy-MM-dd') }}</span>
          </el-form-item>
        </el-col>

        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="维保人员"
            prop="wbryDmList"
          >
            <select-xm-user
              v-model="fd.wbryDmList"
              role-code="WBRY"
              :show-dept="false"
              multiple
              collapse-tags
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="项目负责人"
            prop="xmfzrDm"
          >
            <select-xm-user
              v-model="fd.xmfzrDm"
              role-code="FireEngineer"
              :show-dept="false"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="技术负责人"
            prop="jsfzrDm"
          >
            <select-xm-user
              v-model="fd.jsfzrDm"
              role-code="FireEngineer"
              :show-dept="false"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="维保内容"
            prop="wbnrJhList"
          >
            <el-checkbox-group
              v-model="fd.wbnrJhList"
              class="c-form__checkbox-group"
            >
              <el-checkbox
                v-for="item in wbnrXmList"
                :key="item.wbnrId"
                :label="item.wbnrId"
              >
                {{ item.wbnrMc }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="任务描述"
            prop="rwms"
          >
            <el-input
              v-model="fd.rwms"
              class="c-form__input"
              type="textarea"
              rows="4"
              placeholder="请输入任务描述"
            />
          </el-form-item>
        </el-col>
        <!-- <el-col
          v-if="editShow"
          class="c-form__col c-form__part-title"
          :span="24"
        >
          分配信息
        </el-col> -->
      </el-row>
    </el-form>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <k-button
        btn-text="保存"
        :auth-type="true"
        type="primary"
        @click="handleSave()"
      />
      <k-button
        btn-text="关闭"
        :auth-type="false"
        @click="closeDialog()"
      />
    </div>
  </el-dialog>
</template>

<script>
import { wbjhService } from './wbjh.service';
// import { xfwbglService } from '../xfwbgl.service';
import { wbxmService } from '../wbxm/wbxm.service';
import SelectXmUser from '../../components/SelectXmUser/SelectXmUser.vue';
export default {
  name: 'WbjhUpdateDialog',
  components: { SelectXmUser },
  props: {
    dlParams: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data () {
    return {
      loading: false, // 页面loading计划年份
      dialogShow: true, // 模态框dialog显示
      editShow: false, // 编辑模式显示
      paginationShow: false, // 分页显示
      xmList: [], // 项目列表
      jhmcList: [], // 计划名称列表
      wbryList: [], // 维保人员列表
      wbnrXmList: [], // 维保内容
      jhlxMc: '', // 计划类型名称
      jhnfList: [], // 计划年份列表

      htyxqQ: null, // 合同有效期起
      htyxqZ: null, // 合同有效期止

      /* 表单参数 Start */
      fd: {
        xmId: null, // 项目ID
        xmmc: null, // 项目名称
        jhlxDm: null, // 计划类型
        jhnf: null, // 计划年份
        jhmc: null, // 计划名称
        jhsjQ: null, // 计划开始时间
        jhsjZ: null, // 计划结束时间
        wbzq: null, // 维保周期
        wbryDmList: [], // 维保人员
        xmfzrDm: null, // 项目负责人
        jsfzrDm: null, // 技术负责人
        wbnrJhList: [], // 维保内容
        rwms: '对各系统进行定期维护保养，测试并出具维保报告。' // 任务描述
      },
      /* 表单参数 End */

      /* 表单校验规则 Start */
      fdRules: {
        xmId: [
          this.$validUtils.required('项目名称')
        ], // 客户名称
        jhlxDm: [
          this.$validUtils.required('计划类型')
        ], // 计划类型
        jhnf: [
          this.$validUtils.required('计划年份')
        ], // 计划年份
        jhmc: [
          this.$validUtils.required('计划名称')
        ], // 计划名称
        wbryDmList: [
          this.$validUtils.required('维保人员')
        ], // 维保人员
        jsfzrDm: [
          this.$validUtils.required('技术负责人')
        ], // 技术负责人
        xmfzrDm: [
          this.$validUtils.required('项目负责人')
        ], // 项目负责人
        rwms: [
          this.$validUtils.required('任务描述'),
          this.$HMValidator.maxLength('任务描述', 3000)
        ], // 任务描述
        wbnrJhList: [
          this.$validUtils.required('维保内容')
        ]
      },
      /* 表单校验规则 End */

      /* 查询条件（页面绑定的查询条件） start */
      filterParams: {

      },
      /* 查询条件 end */
      /* 查询结果 Start */
      page: {
        rows: [],
        total: 0,
        pageSize: 15,
        pageNo: 0
      },
      /* 查询结果 End */

      /* 表格列配置Start */
      tableColumn: [
        { key: 'index', label: '序号', align: 'center', width: this.$commonConfig.tableWidthConfig.common_xh, type: 'index' },
        { key: 'zylxMc', label: '作业类型', align: 'left', minWidth: '120', type: 'text' },
        { key: 'jcxmzs', label: '检查项目总数', align: 'left', minWidth: '120', type: 'text' },
        { key: 'yfpjcxs', label: '已分配检查项数', align: 'left', minWidth: '180', type: 'text' }
      ],
      /* 表格列配置End */

      dlType: 'add' // 模态框类型，'add': 新增，'edit': 修改

    };
  },
  computed: {
    /* 根据模态框类型动态展示标题 */
    dlTitle () {
      return `${this.dlType === 'edit' ? '修改维保计划' : '新增维保计划'}`;
    },
    /* 计划类型 */
    jhlxList () {
      const enums = this.$store.state.apiEnums.iffApi;
      if (enums && enums.IFF_JHLX) {
        return enums.IFF_JHLX;
      }
      return {};
    }
  },
  methods: {

    /**
     * @description: 计划类型变化处理
     * @return {*}
     * @param {*} params
     */
    handleJhlxChange (params) {
      this.fd.wbzq = params.text;
      this.fd.jhlxDm = params.id;
      this.jhlxMc = params.text;
      this.handleJhmc(params);
      this.getWbnrList(params.id);
    },
    /**
     * @description: 客户变化处理
     * @return {*}
     */
    handleXmChange () {
      this.fd.wbnrJhList = [];
      // this.fd.wbryDmList = [];
      // this.getWbryList();
      this.jhnfList = [];
      this.handleQueryXmInfo();
    },

    /**
     * @description: 计划名称变化处理
     * @return {*}
     * @param {*} params 计划名称
     */
    handleJhmcChange (params) {
      const _this = this;
      const kssj = new Date();
      kssj.setFullYear(_this.fd.jhnf);
      const jssj = new Date();
      jssj.setFullYear(_this.fd.jhnf);
      if (_this.jhlxMc === '月' || _this.jhlxMc === '月度') {
        kssj.setMonth(params.value);
        jssj.setMonth(params.value + 1);
      } else if (_this.jhlxMc === '季' || _this.jhlxMc === '季度') {
        kssj.setMonth(params.value * 3);
        jssj.setMonth((params.value + 1) * 3);
      } else if (_this.jhlxMc === '半年') {
        kssj.setMonth(params.value * 6);
        jssj.setMonth((params.value + 1) * 6);
      } else if (_this.jhlxMc === '年') {
        kssj.setMonth(0);
        jssj.setMonth(12);
      }
      kssj.setDate(1);
      jssj.setDate(0);
      _this.fd.jhsjQ = kssj;
      _this.fd.jhsjZ = jssj;
    },
    /**
     * @description: 初始化维保计划信息
     * @return {*}
     */
    async init () {
      this.loading = true;
      const _this = this;

      await wbjhService.getInfo(_this.dlParams.id)
        .then(rsp => {
          _this.fd = Object.assign({}, _this.fd, rsp.data);
          _this.fd.wbryDmList = [];
          // 维保人员
          if (rsp.data.wbryDmList) {
            rsp.data.wbryDmList.forEach(e => {
              _this.fd.wbryDmList.push(e.userCode);
            });
          }
          // 维保计划内容
          _this.fd.wbnrJhList = [];
          if (rsp.data.wbnrJhList) {
            rsp.data.wbnrJhList.forEach(e => {
              _this.fd.wbnrJhList.push(e.wbnrDm);
            });
          }
          _this.jhlxMc = rsp.data.jhlxMc;
          _this.getWbnrList(rsp.data.jhlxDm);
        })
        .catch(err => {
          console.error('获取维保计划信息错误！', err);
        })
        .finally(() => {
          _this.loading = false;
        });
      // await this.handleJhlxChange();
      await _this.handleQueryXmInfo(); // 获取维保内容列表
      await _this.handleInitJhmc(_this.fd.jhlxMc); // 初始化计划名称列表
    },
    /**
     * @description: 获取“有效”客户列表
     * @return {*}
     */
    getYxxmList () {
      wbxmService.getYxxmList()
        .then(rsp => {
          this.xmList = rsp.data;
        })
        .catch(err => {
          console.error('获取合同有效项目列表信息错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 获取维保内容列表
     * @return {*}
     */
    getWbnrList (_zyzq) {
      this.loading = true;
      wbxmService.getWbnrList(this.fd.xmId, _zyzq)
        .then(rsp => {
          this.wbnrXmList = rsp.data;
        })
        .catch(err => {
          console.error('获取维保内容列表信息错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 保存操作
     * @param {*}
     * @return {*}
     */
    handleSave () {
      this.$refs.fd.validate((valid) => {
        if (valid) {
          this.loading = true;
          // this.fd.wbryDmList = this.fd.wbryDmList.join(',');
          // this.fd.wbnrJhList = this.fd.wbnrJhList.join(',');
          // this.fd.jhnf = this.fd.jhnf.getFullYear();

          if (this.dlType === 'add') {
            this.addSave();
          } else {
            this.updateSave();
          }
        }
      });
    },
    /**
     * @description: 新增保存服务
     * @return {*}
     */
    addSave () {
      wbjhService.save(this.fd)
        .then(rsp => {
          this.$alert('新增成功！', '提示', {
            confirmButtonText: '确定',
            type: 'success',
            callback: action => {
            }
          });
          this.$emit('closeDialog', '');
          this.$emit('callback');
        })
        .catch(err => {
          console.error('新增建筑错误！', err);
          this.loading = false;
        });
    },
    /**
     * @description: 修改保存
     * @return {*}
     */
    updateSave () {
      wbjhService.update(this.dlParams.id, this.fd)
        .then(rsp => {
          this.$alert('修改成功！', '提示', {
            confirmButtonText: '确定',
            type: 'success',
            callback: action => {
            }
          });
          this.$emit('closeDialog', '');
          this.$emit('callback');
        })
        .catch(err => {
          console.error('修改建筑错误！', err);
          this.loading = false;
        });
    },
    /**
     * @description: 计划名称处理
     * @return {*}
     */
    handleJhmc () {
      this.fd.jhsjQ = null;
      this.fd.jhsjZ = null;
      this.fd.jhmc = null;
      if (!this.fd.jhnf || !this.fd.jhlxDm) {
        return;
      }
      this.handleInitJhmc(this.jhlxMc);
    },

    /**
     * @description: 初始化计划名称
     * @return {*}
     */
    handleInitJhmc (jhlxMc) {
      const _this = this;
      const _year = _this.fd.jhnf;
      _this.jhmcList = [];

      if (jhlxMc === '月' || jhlxMc === '月度') {
        var sjq = new Date(_this.htyxqQ);
        for (; sjq.getTime() <= _this.htyxqZ;) {
          if (sjq.getFullYear() + '' === '' + _year) {
            const _jhmc = _year + '年' + (sjq.getMonth() + 1) + '月维保';
            _this.jhmcList.push({ id: _jhmc, text: _jhmc, value: sjq.getMonth() });
            console.log('_m', _jhmc);
          }
          sjq.setMonth(sjq.getMonth() + 1);
        };
      } else if (jhlxMc === '季' || jhlxMc === '季度') {
        const quarters = ['第一季度', '第二季度', '第三季度', '第四季度'];
        for (var i = 0; i < quarters.length; ++i) {
          const _jhmc = _year + '年' + quarters[i] + '维保';
          _this.jhmcList.push({ id: _jhmc, text: _jhmc, value: i });
        }
      } else if (jhlxMc === '半年') {
        const halfYears = ['上半年', '下半年'];
        for (var j = 0; j < halfYears.length; ++j) {
          const _jhmc = _year + '年' + halfYears[j] + '维保';
          _this.jhmcList.push({ id: _jhmc, text: _jhmc, value: j });
        }
      } else if (jhlxMc === '年') {
        const _jhmc = _year + '年度维保';
        _this.jhmcList.push({ id: _jhmc, text: _jhmc });
      }
    },
    /**
     * @description: 获取项目信息
     * @return {*}
     */
    handleQueryXmInfo () {
      if (!this.fd.xmId) {
        return;
      }
      return new Promise((resolve, reject) => {
        resolve(this.getWbxmInfo());
      });
    },
    async getWbxmInfo () {
      const _this = this;
      await wbjhService.getWbxmInfo(this.fd.xmId)
        .then(rsp => {
          _this.fd.xmId = rsp.data.xmId;
          _this.fd.xmmc = rsp.data.xmmc;
          _this.htyxqQ = rsp.data.htyxqQ;
          _this.htyxqZ = rsp.data.htyxqZ;
          var htyxqQY = new Date(_this.htyxqQ).getFullYear();
          var htyxqZY = new Date(_this.htyxqZ).getFullYear();

          for (; htyxqQY <= htyxqZY; htyxqQY++) {
            _this.jhnfList.push({ id: htyxqQY, text: htyxqQY });
          }
          // this.wbnrXmList = rsp.data.wbnrList;
        })
        .catch(err => {
          console.error('获取维保项目详情信息错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    }
  },
  created () {
    if (this.dlParams.id) {
      this.dlType = 'edit';
      this.fd.xmId = this.dlParams.id;
      this.editShow = (this.dlType === 'edit');
      this.init();
    } else if (this.$route.params.xmId) {
      this.fd.xmId = this.$route.params.xmId;
      this.loading = true;
      this.handleQueryXmInfo(); // 获取项目可取计划年份
    } else {
      this.loading = true;
      // 获取合同有效的项目列表
      this.getYxxmList();
    }
  }
};
</script>
